export enum MessageOriginators {
  LLM = 'LLM',
  USER = 'USER',
}
